import { get, post } from './common'
type ApiBaseResult = ApiTypes.ApiBaseResult
type ApiChapterResponse<T> = ApiTypes.ApiChapterResponse<T>
type ApiResponsePageList<T> = ApiTypes.ApiResponsePageList<T> 
export namespace order {
  /** 订单列表（管理端） */
  // export function getOrderList(params: DataModels.order.OrderListParams): Promise<
  //   ApiBaseResult & {
  //     data: { total: number; list: DataModels.order.OrderListItem[] }
  //   }
  export function getOrderList(params: {
    inviteCode?: string | undefined
    status?: DataModels.order.OrderStatus
    chargeChannel?: DataModels.order.PayMethod
    pageIndex?: number
    pageSize?: number
    goodsName?: string
    /** 开始日期，格式：YYYY-MM-DD */
    createdAtStart?: string | undefined
    /** 结束日期，格式：YYYY-MM-DD */
    createdAtEnd?: string | undefined
    outTradeNo?: string
  }): Promise<
    ApiBaseResult & {
      data: { total: number; list: DataModels.order.OrderListItem[] }
    }
  > {
    return get('/admin/order/list', params)
  }

  export function getOrderListPage(params: {
    status?: DataModels.order.OrderStatus
    pageIndex?: number
    pageSize?: number
    type?:string
  }): Promise<
    ApiBaseResult & {
      data: { total: number; list:DataModels.goods.OrderRepay[] }
    }
  > {
    return get('/order/list', params)
  }

  // 获取优惠券
    export function getCoupopItem(couponId: string): Promise<
      ApiBaseResult & { data: DataModels.Coupon.CouponListItem }
    > {
      return get('/coupon/', { code:couponId })
    }

  // 领取优惠券
    export function receiveCoupopItem(couponId: string): Promise<
    ApiBaseResult & { data: DataModels.Coupon.CouponListItem }
  > {
    return post('/coupon/receive',{}, { code:couponId })
  }

  // 购买某个商品时可用的优惠券列表
 export function getAvaliableCoupons(goodsId: string): Promise<
    ApiResponsePageList <DataModels.Coupon.UseCouponItem> > {
    return get('/coupon/can_use_on_goods', { goodsId })
  }

  // 我的优惠券列表
  export function getCouponMyList(params: {
    pageIndex?: number
    pageSize?: number
  }): Promise<
    ApiBaseResult & {
      data: { total: number; list: DataModels.Coupon.CouponItem[] }
    }
  > {
    return get('/coupon/my_list', params)
  }

  // 我的已购
  export function getOrderPurscedPage(params: {
    pageIndex?: number
    pageSize?: number
  }): Promise<
    ApiBaseResult & {
      data: { total: number; list:DataModels.goods.OrderPurshed[] }
    }
  > {
    return get('/user/vip', params)
  }
// 我的已购附属章节
  export function myPurshedAttach(
    goodsId: string,
  ): Promise<ApiChapterResponse<DataModels.goods.Attachment>> {
    return post('/user/vip/goods_attachments', {}, { goodsId })
  }


  /** 订单详情（管理端） */
  export function getOrderDetail(orderId: string): Promise<
    ApiBaseResult & { data: DataModels.order.OrderDetail }
  > {
    return get('/admin/order/detail', { orderId })
  }

  /** 更新订单状态（管理端） */
  export function updateOrderStatus(
    orderId: string,
    status: DataModels.order.OrderStatus
  ): Promise<ApiBaseResult> {
    return post('/admin/order/update_status', {}, { orderId, status })
  }


  export function updateOrderPrice(
    data:{
      outTradeNo: string,
      amount: number
    }
  ): Promise<ApiBaseResult> {
    return post('/admin/order/price_adjust', {}, data)
  }

  // 取消订单
  export function cancelOrder(outTradeNo: string): Promise<ApiBaseResult> {
    return post('/order/cancel', {}, { outTradeNo })
  }
}
